import Vue from 'vue';
import Router from 'vue-router';
import PharmaDaily from '@/components/PharmaDaily.vue';
import PatChk from '@/components/PatChk.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/pharma-daily',
      name: 'PharmaDaily',
      component: PharmaDaily
    },
    {
      path: '/patchk',
      name: 'PatChk',
      component: PatChk
    },
  ]
});